import { initialState } from '../../providers/global-provider/global-context'
import { AppActionsType, AppState, EXPANDED_Y, LANGTAG, LOG_OUT, REQUIRE_AUTHENTICATOR } from "./types"

export function reducer(state: AppState, action: AppActionsType): AppState {
  switch (action.type) {
    case EXPANDED_Y:
      return { ...state, expandedY: action.payload }
    case REQUIRE_AUTHENTICATOR:
      return { ...state, requireAuthenticator: true, initialState: action.payload ?? 'signUp' }
    case LANGTAG:
      return { ...state, langtag: action.payload }
    case LOG_OUT:
      return initialState
    default:
      return state
  }
}
